<template>
    <div class="about">
        <Header></Header>
        <div class="main-about">
            <div class="nav-banner">
                <div class="box">
                    <div class="left">
                        <h2>快速实现用户新增和转化</h2>
                        <p>
                            推动银行业全面拥抱互联网，提升各级银行机构的运营效率，降低运营成本
                        </p>
                        <div>
                            <a @click="denglu" class="btn">立即试用</a>
                        </div>
                    </div>
                    <div class="right">
                        <img src="" alt="" />
                    </div>
                </div>
            </div>
            <div class="chengji">
                <div class="contain">
                    <h2>2020年契合科技的成绩</h2>
                    <div class="box">
                        <div class="item">
                            <h3>360 <span>场</span></h3>
                            <p>定制化活动</p>
                        </div>
                        <div class="item">
                            <h3>3000 <span>W+</span></h3>
                            <p>参与用户</p>
                        </div>
                        <div class="item">
                            <h3>200 <span>W+</span></h3>
                            <p>有效裂变人数</p>
                        </div>
                        <div class="item">
                            <h3>200 <span>W+</span></h3>
                            <p>新增客户</p>
                        </div>
                    </div>
                    <div class="text-item">
                        <p>
                            由于疫情原因及用户消费习惯改变等影响，近年来银行等金融机构开始数字化经营的转型；契合科技活动平台支撑了金融机构客户在2020年支持开展超2000场次活动。
                        </p>
                    </div>
                    <div class="text-item">
                        <p>
                            建设银行，总行全国性活动，定制化及活动平台开展活动
                            200+ 场次，参与用户数量超过 3000 万人；
                        </p>
                    </div>
                    <div class="text-item">
                        <p>
                            中信银行，云营销Club裂变平台，累计有效推荐人 200
                            万+；
                        </p>
                    </div>
                    <div class="text-item">
                        <p>
                            2020 年开展活动 600 多场，给行内新增客户 60
                            多万户，新增客户资产 1500 亿。
                        </p>
                    </div>
                    <div class="text-item">
                        <p>
                            契合科技实施了建设银行、工商银行、兴业银行等多家城商银行的数字化营销平台项目，助力城商行快速具备线上数字化营销的能力。
                        </p>
                    </div>
                </div>
            </div>
            <div class="case">
                <div class="contain">
                    <h2>契合科技案例精选</h2>
                    <div class="box">
                        <div class="ind1">
                            <div class="ind2">
                                <div :class="[ch==1?'ind4':'ind3']" @click="tapH(1)">建设银行</div>
                                <div :class="[ch==2?'ind4':'ind3']" @click="tapH(2)">工商银行</div>
                                <div :class="[ch==3?'ind4':'ind3']" @click="tapH(3)">兴业银行</div>
                            </div>
                            <div class="ind5" v-if="ch==1">
                                <div class="ind6">建设银行数字化营销</div>
                                <img src="../../assets/ychy/img36.jpg" class="in8"/>
                                <div class="ind7">打造国有大行数字化营销新模式：主题会场+客群活动两手抓，上亿流量及千万奖池规模，助力业务指标转化！</div>
                            </div>
                            <div class="ind5" v-if="ch==2">
                                <div class="ind6">工商银行</div>
                                <img src="../../assets/ychy/img35.jpg" class="in8"/>
                                <div class="ind7">MGM裂变营销平台，提供MGM活动制作、发布、权益激励、分支行业绩统计近5年来，助力于平台迭代与运维，累计开展活动上千场，获客人数百万以上</div>
                            </div>
                            <div class="ind5" v-if="ch==3">
                                <div class="ind6">兴业银行</div>
                                <img src="../../assets/ychy/img34.jpg" class="in8"/>
                                <div class="ind7">契合科技营销平台进行私有化部署，丰富了行内系统的营销形式和内容，与行内业务数据实现互通，成为运营营销工作有力的抓手。</div>
                            </div>
                        </div>
                        <!-- <div class="item">
                            <div class="iocn">
                                <img
                                    src="../../assets/ychy/img36.jpg"
                                    alt=""
                                />
                            </div>
                            <div class="text">
                                <p>建设银行</p>
                                <p>2019 年 - 2021 年营销解决方案</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="iocn">
                                <img
                                    src="../../assets/ychy/img35.jpg"
                                    alt=""
                                />
                            </div>
                            <div class="text">
                                <p>工商银行</p>
                                <p>2019 年 — 2021 年云营销 Club</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="iocn">
                                <img
                                    src="../../assets/ychy/img34.jpg"
                                    alt=""
                                />
                            </div>
                            <div class="text">
                                <p>兴业银行</p>
                                <p>2020 年 — 2021 年智能营销平台</p>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <bgred></bgred>
            <contain></contain>
        </div>
    </div>
</template>

<script>
import Header from "@/components/header1";
import bgred from "../../components/bgred.vue";
import contain from "../../components/contain.vue";
export default {
    components: {
        Header,
        bgred,
        contain,
    },
    data() {
        return {
            ch: 1
        };
    },
    mounted() {},
    methods: {
        denglu() {
            this.$router.push({
                path: "/login",
            });
        },
        tapH(e){
            this.ch=e;
        }
    },
};
</script>

<style scoped>
.main-about {
}
.nav-banner {
    width: 100%;
    height: 505px;
    background: linear-gradient(221deg, #3060eb, #2970eb);
}
.nav-banner .box {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    background: url(https://ccbhdimg.kerlala.com/hd/website/urthink/case_ban.png)
        100% 100% no-repeat;
    background-size: 651px auto;
}
.nav-banner .box .left {
    text-align: left;
}
.nav-banner .box .left h2 {
    padding-top: 145px;
    font-size: 44px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #fff;
    line-height: 44px;
}
.nav-banner .box .left p {
    padding-top: 30px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #fff;
    line-height: 20px;
}
.nav-banner .box .left .btn {
    display: block;
    margin-top: 52px;
    text-align: center;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #fff;
    line-height: 57px;
    width: 162px;
    height: 57px;
    background: hsla(0, 0%, 100%, 0);
    border-radius: 4px;
    border: 1px solid hsla(0, 0%, 100%, 0.7);
    box-sizing: border-box;
}
.main-about h2 {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #595961;
    line-height: 32px;
}
.main-about .chengji {
    text-align: center;
    padding: 80px 0 102px;
    box-sizing: border-box;
    background: url(https://ccbhdimg.kerlala.com/hd/website/urthink/chengji_bg.png)
        no-repeat;
    background-size: 100% 100%;
}
.main-about .chengji h2 {
    margin-bottom: 67px;
}
.main-about .chengji .box {
    width: 1200px;
    margin: 0 auto;
    display: flex;
}
.main-about .chengji .box .item {
    flex: 1;
    margin: 0 48px 66px;
}
.main-about .chengji .box .item h3 {
    margin-bottom: 11px;
    font-size: 60px;
    font-weight: 600;
    color: #333;
    line-height: 60px;
}
.main-about .chengji .box .item h3 span {
    font-size: 20px;
}
.main-about .chengji .text-item {
    width: 1180px;
    margin: 0 auto;
}
.main-about .chengji .text-item p {
    font-size: 20px;
    color: #595961;
    line-height: 40px;
}
.main-about .case {
    background: #fff;
    padding: 80px 0 100px;
    width: 1200px;
    margin: 0 auto;
}
.case {
    padding-bottom: 91px;
}
.main-about .case h2 {
    margin-bottom: 34px;
    font-size: 36px;
    color: #333334;
    line-height: 36px;
    text-align: center;
}
.main-about .case .box {
    display: flex;
    justify-content: space-around;
}
.main-about .case .box .item {
    width: 380px;
    height: 360px;
    position: relative;
}
.main-about .case .box .item img {
    width: 100%;
}
.main-about .case .box .item {
    width: 380px;
    height: 360px;
    position: relative;
}
.main-about .case .box .item .text {
    position: absolute;
    width: 100%;
    bottom: 29px;
    left: 0;
    height: 90px;
    background: linear-gradient(270deg, rgba(46, 152, 176, 0), #2e98b0);
    text-align: left;
    padding: 16px 28px;
    overflow: hidden;
    box-sizing: border-box;
}
.main-about .case .box .item:first-child .text {
    background: linear-gradient(
        270deg,
        rgba(23, 52, 121, 0.25),
        rgba(23, 52, 121, 0.8)
    );
}
.main-about .case .box .item .text p {
    font-size: 21px;
    color: #fff;
}
.main-about .case .box .item .text p:first-child {
    font-size: 28px;
}
.ind1{
    display: block;
}
.ind2{
    display: flex;
    justify-content: center;
    margin-top: 30px;
}
.ind3{
    width: 229px;
    height: 56px;
    line-height: 56px;
    font-size: 18px;
    background: #fff;
    border: 1px solid #ddd;
    font-weight: 400;
    color: #333;
    cursor: pointer;
}
.ind4{
    width: 229px;
    height: 56px;
    line-height: 56px;
    font-size: 18px;
    background: #fff;
    border: 1px solid #4b8bff;
    font-weight: 500;
    color: #4b8bff;
    cursor: pointer;
}
.ind5{
    width: 1012px;
    margin: 0px auto;
    margin-bottom: 0;
}
.ind6{
    margin-bottom: 18px;
    font-size: 22px;
    font-family: PingFangSC-Medium,PingFang SC;
    font-weight: 500;
    color: #333;
    float: left;
    margin-top: 121px;
    margin-left: 130px;
}
.ind7{
    width: 273px;
    font-size: 14px;
    font-weight: 400;
    color: #666;
    line-height: 26px;
    text-align: justify;
    float: left;
    margin-left: 130px;
}
.in8{
    width: 300px;
    float: right;
    margin-right: 130px;
    margin-top: 50px;
}
</style>


// WEBPACK FOOTER //
// src/views/aoveras/caseList.vue